
interface V3IconMagnifierProps extends React.SVGProps<SVGSVGElement> {
    stroke?: string;
}

export const V3IconMagnifier = ({ stroke = "#ABB0BA", ...rest }: V3IconMagnifierProps) => <svg width="16" height="16" {...rest} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 12A5 5 0 1 0 7 2a5 5 0 0 0 0 10ZM14 14l-4-4" stroke={stroke} strokeWidth="1.5" />
</svg>
